import React, { Component } from 'react';

interface State {
  compact: boolean;
  text: string;
  emoji: string;
}

interface Props {
  onConfirm: (comment: { text: string; emoji: string }) => void;
  onOpen: () => void;
  onUpdate?: () => void;
}

/**
 *
 * @description We used this tips as a copy from basic node modules files of the react-pdf-highlighter
 *  to remove emojis totally as required
 * @export
 * @class Tip
 * @extends {Component<Props, State>}
 */
export class Tip extends Component<Props, State> {
  state: State = {
    compact: true,
    text: '',
    emoji: '',
  };

  componentDidUpdate(nextProps: Props, nextState: State) {
    const { onUpdate } = this.props;

    if (onUpdate && this.state.compact !== nextState.compact) {
      onUpdate();
    }
  }

  render() {
    const { onConfirm, onOpen } = this.props;
    const { compact, text, emoji } = this.state;

    return (
      <div className='Tip'>
        {compact ? (
          <div
            className='Tip__compact'
            onClick={() => {
              onOpen();
              this.setState({ compact: false });
            }}
          >
            Add highlight
          </div>
        ) : (
          <form
            className='Tip__card'
            onSubmit={(event) => {
              event.preventDefault();
              onConfirm({ text, emoji });
            }}
          >
            <div>
              <textarea
                placeholder='Your comment'
                autoFocus
                value={text}
                onChange={(event) => this.setState({ text: event.target.value })}
                ref={(node) => {
                  if (node) {
                    node.focus();
                  }
                }}
              />
            </div>
            <div>
              <input type='submit' value='Save' />
            </div>
          </form>
        )}
      </div>
    );
  }
}

export default Tip;
